import { render, staticRenderFns } from "./Baoming.vue?vue&type=template&id=1a88b130&scoped=true"
import script from "./Baoming.vue?vue&type=script&lang=js"
export * from "./Baoming.vue?vue&type=script&lang=js"
import style0 from "./Baoming.vue?vue&type=style&index=0&id=1a88b130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a88b130",
  null
  
)

export default component.exports